
// src/App.js
import React, { useEffect, useState } from 'react';
import { RouterProvider } from "react-router-dom";
import router from './routing/route';
import AnimatedScene from './AnimatedScene';
import Glitch from './glitch';
import Main from './main';
import CustomCursor from './customCurser';
import { MouseProvider } from './mousHoverContext';
import { VisitedProvider } from './visitedContext.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ColoredProvider } from './color.js';
import { SnackbarProvider, useSnackbar } from "notistack";



function App() {
  const [currentComponent, setCurrentComponent] = useState(1);


  useEffect(() => {
    // Timer for showing the second component
    const firstTimer = setTimeout(() => {
      setCurrentComponent(2);
    }, 55); // 3 seconds for first transition

    // Timer for showing the third component after showing the second
    const secondTimer = setTimeout(() => {
      setCurrentComponent(3);
    }, 110); // 6 seconds in total (3s + 3s) for second transition

    // Clear timers if the component unmounts
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(secondTimer);
    };
  }, []);

  return (
    <div className="App">

      <MouseProvider>
      <VisitedProvider>
      <SnackbarProvider maxSnack={3} autoHideDuration={9000}>

      <ColoredProvider>

      {window.innerWidth>900 && <CustomCursor/> }

      <RouterProvider router={router} />
      </ColoredProvider>
      </SnackbarProvider>

      </VisitedProvider>
      </MouseProvider>
        </div>
  );
}

export default App;

